(function (w) {
  'use strict';

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function inline(text) {
    return escapeHtml(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  }

  function isOrderedItem(line) {
    return /^\s*\d+\.\s+/.test(line);
  }

  function isUnorderedItem(line) {
    return /^\s*[-*]\s+/.test(line);
  }

  function nextNonEmptyIndex(lines, from) {
    var j = from;
    while (j < lines.length && !lines[j].trim()) j += 1;
    return j;
  }

  function collectListItems(lines, start, testItem) {
    var items = [];
    var i = start;
    while (i < lines.length) {
      if (testItem(lines[i])) {
        items.push(lines[i]);
        i += 1;
        continue;
      }
      if (!lines[i].trim()) {
        var next = nextNonEmptyIndex(lines, i + 1);
        if (next < lines.length && testItem(lines[next])) {
          i = next;
          continue;
        }
        break;
      }
      break;
    }
    return { items: items, next: i };
  }

  function isBlockStart(line) {
    var t = line.trim();
    return (
      !t ||
      /^#{1,6}\s/.test(line) ||
      /^---+$/.test(t) ||
      isUnorderedItem(line) ||
      isOrderedItem(line)
    );
  }

  function parse(md) {
    var lines = String(md || '').replace(/\r\n/g, '\n').split('\n');
    var html = [];
    var i = 0;

    while (i < lines.length) {
      var line = lines[i];
      var trimmed = line.trim();

      if (!trimmed) {
        i += 1;
        continue;
      }

      if (/^---+$/.test(trimmed)) {
        html.push('<hr>');
        i += 1;
        continue;
      }

      var heading = line.match(/^(#{1,6})\s+(.*)$/);
      if (heading) {
        var level = heading[1].length;
        html.push('<h' + level + '>' + inline(heading[2]) + '</h' + level + '>');
        i += 1;
        continue;
      }

      if (isOrderedItem(line)) {
        var ordered = collectListItems(lines, i, isOrderedItem);
        html.push('<ol>');
        ordered.items.forEach(function (itemLine) {
          html.push('<li>' + inline(itemLine.replace(/^\s*\d+\.\s+/, '')) + '</li>');
        });
        html.push('</ol>');
        i = ordered.next;
        continue;
      }

      if (isUnorderedItem(line)) {
        var unordered = collectListItems(lines, i, isUnorderedItem);
        html.push('<ul>');
        unordered.items.forEach(function (itemLine) {
          html.push('<li>' + inline(itemLine.replace(/^\s*[-*]\s+/, '')) + '</li>');
        });
        html.push('</ul>');
        i = unordered.next;
        continue;
      }

      var para = [];
      while (i < lines.length && !isBlockStart(lines[i])) {
        para.push(lines[i].trim());
        i += 1;
      }
      if (para.length) {
        html.push('<p>' + inline(para.join(' ')) + '</p>');
      }
    }

    return html.join('\n');
  }

  function render(root) {
    var nodes = (root || document).querySelectorAll('[data-c27-support-md]');
    nodes.forEach(function (el) {
      if (el.getAttribute('data-c27-support-md-rendered') === '1') return;
      var raw = el.textContent || '';
      el.innerHTML = parse(raw);
      el.setAttribute('data-c27-support-md-rendered', '1');
      el.removeAttribute('data-c27-support-md');
    });
  }

  w.C27SupportMarkdown = { parse: parse, render: render };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      render(document);
    });
  } else {
    render(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    render(event.target);
  });
})(window);
